import React, { Component, Fragment } from "react";
import map from "lodash.map";
import orderBy from "lodash.orderby";
import isEmpty from "lodash.isempty";
import isEqual from "lodash.isequal";
import cloneDeep from "lodash.clonedeep";
import get from "lodash.get";
import moment from "moment";
import { Formik } from "formik";
import Form from "react-bootstrap/lib/Form";
import {
  ProjectStatus,
  ProjectMode,
  ConsultationFormStatus,
  ProjectType,
  ExpendActionType,
} from "../../../utils/enums";
import { dayFormat } from "../../../utils/date";
import { ButtonLoader } from "../../ButtonLoader";
import { Button } from "../../Button";
import { ChartPieWrapper as ResponsivePie } from "../../ChartWrapper";

export default class ProjectListProbeItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      canVote: this.canVote(),
      isVoted: this.isVoted(),
    };

    this.toggleOpen = (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (this.props.opened) {
        this.props.onSetExpandStateItem(ExpendActionType.remove, this.props.id);
      } else {
        this.props.onSetExpandStateItem(ExpendActionType.add, this.props.id);
      }
    };
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(prevProps.consultationForms, this.props.consultationForms)) {
      this.setState({
        canVote: this.canVote(),
        isVoted: this.isVoted(),
      });
    }
  }

  canVote() {
    const isCanVote = !isEmpty(this.props.consultationForms)
      ? this.props.consultationForms.some(
          (item) =>
            !item.voted &&
            !item.outOfRangeVoteDates &&
            !item.outOfRangeDistricts
        )
      : false;

    return isCanVote;
  }
  isVoted() {
    const isVoted = !isEmpty(this.props.consultationForms)
      ? this.props.consultationForms.every((item) => item.voted)
      : false;

    return isVoted;
  }

  renderProbeInfo(props) {
    const {
      dateFrom,
      dateTo,
      modeName,
      onlyForLegalAge,
      isOnlyOneOffice,
      officeName,
      isAuth,
      isVoted,
    } = props;

    return (
      <div className="consultation-item__infos">
        <div className="consultation-item__info">
          <div className="consultation-item__info-label">Czas trwania od: </div>
          <div className="consultation-item__info-value">{`${dayFormat(
            dateFrom
          )}`}</div>
          <div className="consultation-item__info-label"> do: </div>
          <div className="consultation-item__info-value">{`${dayFormat(
            dateTo
          )}`}</div>
        </div>
        <div className="consultation-item__info">
          <div className="consultation-item__info-label">Tryb:</div>
          <div className="consultation-item__info-value">{modeName}</div>
        </div>
        <div className="consultation-item__info">
          <div className="consultation-item__info-label">
            Tylko dla pełnoletnich:
          </div>
          <div className="consultation-item__info-value">
            {onlyForLegalAge ? "Tak" : "Nie"}
          </div>
        </div>
        {isAuth && (
          <div className="consultation-item__info">
            <div className="consultation-item__info-label">Oddany głos:</div>
            <div className="consultation-item__info-value">
              {isVoted ? "Tak" : "Nie"}
            </div>
          </div>
        )}
        {!isOnlyOneOffice && (
          <div className="consultation-item__info">
            <div className="consultation-item__info-label">Jednostka: </div>
            <div className="consultation-item__info-value">{officeName}</div>
          </div>
        )}
      </div>
    );
  }

  onSingleChange(
    questionAnswer,
    value,
    loggedUserId = -1,
    categoryId = 0,
    questionId = 0
  ) {
    if (
      questionAnswer &&
      questionAnswer.answerOptions &&
      questionAnswer.answerOptions[0] &&
      (questionAnswer.answerOptions[0].id > 0 ||
        questionAnswer.answerOptions[0].questionOptionId > 0)
    ) {
      let answerToUpdate = cloneDeep(questionAnswer);
      answerToUpdate.answerOptions[0].questionOptionId = value;

      return answerToUpdate;
    } else {
      let newAnswer = [
        {
          id: 0,
          questionId: questionId,
          userId: loggedUserId || -1,
          categoryId: categoryId,
          answerOptions: [
            {
              id: 0,
              comment: "",
              openText: "",
              openDate: null,
              questionOptionId: value,
              questionMatrixValueId: 0,
            },
          ],
        },
      ];

      return newAnswer;
    }
  }

  getProbeQuestion(props) {
    let { consultationForms: immutableConsultationForms } = props;
    const question = get(
      props,
      "consultationForms[0].categories[0].questions[0]",
      null
    );

    return question
      ? question
      : {
          content: "",
          questionOptions: [],
        };
  }

  renderProbeItem(props) {
    const {
      id,
      status,
      votedForAllForms,
      mode,
      onlyForLegalAge,
      isLegalAgeUser,
      isAuth,
      loggedOfficeId,
      loggedUserId,
      officeId,
      dateFromMoment,
      dateToMoment,
      dateTimeNow,
      canVote,
      consultationForms,
      onSaveProjectVote,
      isExecuting,
      resultSummary,
      agreementAcceptedRequired = false,
      agreementAccepted = false,
      stateAgreementAccepted = false,
      projectType = ProjectType.Probe,
      scrollToAgreement = Function.prototype,
      disabled = false,
      key,
      loggedUserIsCitizen = false,
    } = props;

    const question = this.getProbeQuestion(props);
    const consultationForm =
      consultationForms && consultationForms[0]
        ? consultationForms[0]
        : undefined;
    const consultationFormDisabled =
      (consultationForm.status !== ConsultationFormStatus.Active ||
        votedForAllForms ||
        !canVote ||
        (onlyForLegalAge ? !isLegalAgeUser : false) ||
        (mode === ProjectMode.Citizen
          ? !isAuth || !loggedUserIsCitizen || officeId !== loggedOfficeId
          : false) ||
        ((mode === ProjectMode.Close ? !isAuth : false) &&
          dateFromMoment.isSameOrBefore(dateTimeNow) &&
          dateToMoment.isSameOrAfter(dateTimeNow))) &&
      status === ProjectStatus.Active;
    const totalVotes = !isEmpty(resultSummary)
      ? resultSummary.reduce((prev, curr) => prev + curr.total, 0)
      : 0;
    let totalPercentage = 0;
    let summaries = !isEmpty(resultSummary)
      ? orderBy(
          map(resultSummary, (summary) => {
            let percentage =
              totalVotes > 0
                ? parseFloat(((summary.total / totalVotes) * 100).toFixed(2))
                : 0;
            if (percentage + totalPercentage > 100) {
              percentage = parseFloat((100 - totalPercentage).toFixed(2));
            }
            totalPercentage += percentage;
            const text = `${percentage}% - ${summary.questionOptionContent} (ilość głosów: ${summary.total})`;
            return {
              id: text,
              label: text,
              value: summary.total,
              percentage: percentage,
            };
          }),
          ["value"],
          ["desc"]
        )
      : map(orderBy(question.questionOptions, ["order"]), (option) => {
          const text = `0% - ${option.content} (ilość głosów: 0)`;
          return { id: text, label: text, value: 0 };
        });

    return (
      <div
        className={`consultation-item ${
          status > ProjectStatus.Active ? "archive-probe-item" : ""
        }`}
      >
        <div className="consultation-item__body">
          {status === ProjectStatus.Active && (
            <Formik
              initialValues={consultationForm}
              render={({
                values,
                handleChange,
                handleBlur,
                isValid,
                errors,
                setFieldValue,
                isSubmitting,
                setSubmitting,
              }) => (
                <Form
                  className="probe-item"
                  noValidate
                  method="post"
                  onSubmit={(e) => {
                    e.preventDefault();
                    if (
                      !stateAgreementAccepted &&
                      agreementAcceptedRequired &&
                      (projectType === ProjectType.Consultation ||
                        projectType === ProjectType.PublicBudget)
                    ) {
                      scrollToAgreement();
                    } else {
                      setSubmitting(true);
                      const newValues = {
                        ...values,
                        agreementAccepted: stateAgreementAccepted,
                      };
                      onSaveProjectVote(id, [newValues]);
                      setSubmitting(false);
                    }
                  }}
                >
                  <div className="probe-item__content">
                    <div className="probe-item__question">
                      <h2
                        className="title title--sub title--alert title--top-0 title--bottom-20"
                        tabIndex="0"
                        role="form"
                        aria-level="2"
                      >
                        {question.content}
                      </h2>
                      <div className="survey-question-options">
                        <div className="question-options" role="radiogroup">
                          {map(
                            orderBy(question.questionOptions, ["order"]),
                            (option, index) => {
                              const answerOption = get(
                                values,
                                "categories[0].questions[0].answers[0].answerOptions[0]",
                                null
                              );
                              const checked =
                                option.id ===
                                (answerOption
                                  ? answerOption.questionOptionId
                                  : -1);
                              return (
                                <Fragment>
                                  <p
                                    style={{
                                      visibility: "hidden",
                                      width: "0px",
                                      height: "0px",
                                      display: "none",
                                    }}
                                    id={`probe-${id}-question-option-${index}`}
                                  >
                                    {`${option.content} odpowiedź do pytania ${question.content}`}
                                  </p>
                                  <label
                                    className="question-options__option radio"
                                    tabIndex="0"
                                    role="radio"
                                    key={`consultationForms.0.categories.0.questions.${index}.answers`}
                                    aria-label={option.content}
                                  >
                                    <input
                                      type="radio"
                                      disabled={
                                        consultationFormDisabled || disabled
                                      }
                                      className="question-options__option-input"
                                      id={`project${id}.consultationForms.0.categories.0.questions.0.answers.${index}`}
                                      name={`project${id}.consultationForms.0.categories.0.questions.0.answers`}
                                      value={option.id}
                                      onBlur={handleBlur}
                                      onChange={(e) => {
                                        const categoryId =
                                          values.categories[0].id;
                                        const questionId =
                                          values.categories[0].questions[0].id;

                                        let newAnswer = this.onSingleChange(
                                          question.answers,
                                          parseInt(e.target.value),
                                          loggedUserId,
                                          categoryId,
                                          questionId
                                        );

                                        setFieldValue(
                                          `categories[0].questions[0].answers`,
                                          newAnswer
                                        );
                                      }}
                                      checked={checked}
                                      aria-labelledby={`probe-${id}-question-option-${index}`}
                                    />
                                    <span className="row row--align-center question-options__option-button">
                                      {option.content}
                                    </span>
                                  </label>
                                </Fragment>
                              );
                            }
                          )}
                        </div>
                      </div>
                    </div>

                    {!disabled &&
                      !votedForAllForms &&
                      canVote &&
                      status === ProjectStatus.Active &&
                      consultationForm.status ===
                        ConsultationFormStatus.Active &&
                      dateFromMoment.isSameOrBefore(dateTimeNow) &&
                      dateToMoment.isSameOrAfter(dateTimeNow) &&
                      (onlyForLegalAge ? isLegalAgeUser : true) &&
                      (mode === ProjectMode.Citizen
                        ? isAuth &&
                          loggedUserIsCitizen &&
                          officeId === loggedOfficeId
                        : true) &&
                      (mode === ProjectMode.Close ? isAuth : true) && (
                        <div className="consultations__projects margin-top-10">
                          {isExecuting && (
                            <ButtonLoader
                              variant="danger"
                              disabled={isExecuting}
                              isExecuting={isExecuting}
                              executingText={"Zapisywanie"}
                            />
                          )}
                          {!isExecuting && (
                            <Button type="submit" size="lg" variant="primary">
                              Zagłosuj
                            </Button>
                          )}
                        </div>
                      )}
                  </div>
                </Form>
              )}
            />
          )}
          {!isEmpty(summaries) && (
            <div className="probe-item__results-chart">
              <div className="text text--alert text--weight-700 text--font-size-14 probe-item__summary-header">
                {status === ProjectStatus.Active ? "Bieżące wyniki" : "Wyniki"}
              </div>
              <ResponsivePie summaries={summaries} />
              <div className="text text--alert text--bottom-10 text--weight-700 text--font-size-14 probe-item__summary-text">
                Łączna ilość głosów: {totalVotes}
              </div>
            </div>
          )}
          {status !== ProjectStatus.Active && this.renderProbeInfo(props)}
        </div>
        <div className="consultation-item__footer">
          {status === ProjectStatus.Active && this.renderProbeInfo(props)}
        </div>
      </div>
    );
  }

  render() {
    const { isVoted, canVote, availableVoteForms, voteForms } = this.state;
    const { title, dateFrom, dateTo, status, opened } = this.props;

    const dateTimeNow = moment();
    const dateToMoment = moment(dateTo);
    const dateFromMoment = moment(dateFrom);

    const probeItem = this.renderProbeItem({
      ...this.props,
      isVoted,
      canVote,
      availableVoteForms,
      voteForms,
      dateTimeNow,
      dateToMoment,
      dateFromMoment,
    });

    const question = this.getProbeQuestion(this.props);

    return (
      <Fragment>
        {status > ProjectStatus.Active && (
          <div className="consultations__item">
            <div className={`consultations__header`} onClick={this.toggleOpen}>
              <div className="consultations__title">{question.content}</div>
              <div className="consultations__icons">
                <div
                  className="consultations__switch consultations__switch--primary-dark"
                  onClick={this.toggleOpen}
                >
                  {opened ? "Zwiń" : "Rozwiń"}
                  {
                    <i
                      className={`consultations__icon fas fa-angle-${
                        opened ? "up" : "down"
                      }`}
                    />
                  }
                </div>
              </div>
            </div>
            {opened && <div className="consultations__body">{probeItem}</div>}
          </div>
        )}
        {status <= ProjectStatus.Active && probeItem}
      </Fragment>
    );
  }
}
